import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import './UserNotificationsModal.css';

function formatTime(ts) {
  try {
    const d = new Date(ts);
    return d.toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '';
  }
}

export default function UserNotificationsModal({ isOpen, onClose, items }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen || typeof document === 'undefined' || !document.body) return null;

  const handleItemClick = (item) => {
    onClose();
    if (item.path === '/profile' && item.profileSection) {
      navigate('/profile', { state: { section: item.profileSection } });
      return;
    }
    navigate(item.path || '/profile');
  };

  return createPortal(
    <div
      className="user-notifications-overlay"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="user-notifications-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="user-notifications-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="user-notifications-header">
          <h2 id="user-notifications-title">Notifications</h2>
          <button
            type="button"
            className="user-notifications-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="user-notifications-body">
          {!items || items.length === 0 ? (
            <p className="user-notifications-empty">No notifications yet.</p>
          ) : (
            <ul className="user-notifications-list">
              {items.map((item) => (
                <li key={item.id}>
                  <button
                    type="button"
                    className="user-notifications-item"
                    onClick={() => handleItemClick(item)}
                  >
                    <span className="user-notifications-item-title">
                      {item.title || 'Notification'}
                    </span>
                    <span className="user-notifications-item-msg">
                      {item.message}
                    </span>
                    <span className="user-notifications-item-meta">
                      {formatTime(item.createdAt)}
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
